<template>
    <div>
      <div v-if="(isCourier || isAdmin) && req.status=='Despachado'">
        <card :title="'Solicitud de Muestra N° '+id " icon="glass-martini" bg="bg-dark text-white"  :id="id" :exportXlsx="true" @exportRequest="exportRequest(id)">
            <template v-slot:titleBadge>
                <management-countdown-badge :deadline="req.dispatchManagementDeadline" :sample-state="req.sampleState" />
            </template>
            <card class="card cardShadow-light" title="Datos Principales">
                <div class="table-responsive">
                    <table class="table">
                        <tr>
                            <th style="width: 20%">Unidad de Negocio:</th>
                            <td style="width: 30%">{{ req.businessUnitName }}</td>
                            <th style="width: 20%">Centro de Costo:</th>
                            <td style="width: 30%">{{ req.costCenterName }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Despacho Progresivo:</th>
                            <td style="width: 30%">{{ req.progressDispatch }}</td>
                            <th style="width: 20%">Objetivo de la Muestra:</th>
                            <td style="width: 30%">{{ req.sampleTargetName }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Detalles de objetivo:</th>
                            <td style="width: 30%">{{ req.sampleReasonName }}</td>
                            <th style="width: 20%">Fecha de Envío:</th>
                            <td style="width: 30%">{{ req.sendedAtString }}</td>
                        </tr>
                        <tr>
                            <th style="width: 20%">Fecha Requerida Despacho:</th>
                            <td style="width: 30%">{{ req.requiredDispatchDateString }}</td>
                            <th style="width: 20%">Fecha/Hora Límite de Gestión:</th>
                            <td style="width: 30%">
                                <span v-if="req.dispatchManagementDeadlineString">{{ req.dispatchManagementDeadlineString }}</span>
                                <span v-else-if="req.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
                                <span v-else class="text-muted">Sin Registro</span>
                            </td>
                        </tr>
                    </table>
                </div>
               
            </card>   
            <card title="Datos de despacho" class="card mt-2 cardShadow-light" >
            <div class="card border-secondary">
                <div v-if="existDispatch" class="table-responsive">
                    <table class="table">
                        <tr>
                            <th>Nombre de Empresa/Cliente:</th>
                            <td>{{ dispatch.enterpriseName }}</td>
                            <th>País</th>
                            <td>{{ dispatch.country.name }}</td>
                            <th>Ciudad:</th>
                            <td>{{ dispatch.city.name }}</td>
                            
                        </tr>
                        <tr>
                            <th>Código Postal</th>
                            <td>{{ dispatch.postalCode }}</td>
                            <th>Dirección:</th>
                            <td>{{ dispatch.address}}</td>
                            <th>Segunda Dirección:</th>
                            <td>{{ dispatch.secondAddress}}</td>
                        </tr>
                        <tr>
                            <th>Teléfono:</th>
                            <td>{{ dispatch.phoneNumber }}</td>
                            <th>Email:</th>
                            <td>{{ dispatch.email }}</td>
                            <th>Contacto (Sr./Sra.):</th>
                            <td>{{ dispatch.contactName }}</td>
                        </tr>
                        <tr>
                            <th>Observaciones:</th>
                            <td>{{ dispatch.remarks }}</td>
                        </tr>
                    </table>
                </div>
               <alert v-else message="Aún no se registra Despacho" />
            </div>        
        </card>     
        </card>
        
        <list-dispatch @updateObservations="updateObservations"  :details="details" :tracking="tracking"  :id="id" :components="components" :progressDispatch="req.progressDispatch"/>
        
      </div>
    </div>
</template>

<script>
import {Get} from '../../../helper/axios.js'
import Card from '../../../components/Card.vue'
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
    components: {
        Card,
    },
    data() {
        return {
            id: this.$route.params.id,
            apiUrl: this.$store.getters.apiUrl,
            isCourier: this.$store.getters.isCourier,
            isAdmin: this.$store.getters.isAdmin,
            Get,
            req: {},
            existDispatch: false,
            details: [],
            components: [],
            tracking: []
        }
    },
    created() {     
        if (this.id) {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/requestsamples/'+this.id, (res) => {
                this.req = res.data;
                this.$store.commit("setLoading", false);
            });
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/dispatchs?sampleId='+this.id, (res) => {
                this.dispatch = res.data;
                this.existDispatch = true;
                this.$store.commit("setLoading", false);
            }, () =>{  
                this.existDispatch = false;       
                }
            )
        }
        this.getDetails();
        this.getComponent();
        this.getTrackings();
        
    },
    methods: {
        updateObservations(){
            this.getDetails();
        },
        getDetails() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/requestsample/${this.id}/details`, (res) => {
                this.details = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getComponent() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/selectedComponents', (res) => {
                    this.components = res.data
                    this.$store.commit("setLoading", false);
            })
        },
        getTrackings() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl+'v1/trackings/', (res) => {
                    this.tracking = res.data
                    this.$store.commit("setLoading", false);
            })
        },
        exportRequest(id){
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/exportRequestSample/"+id, (res) => {
                var array = base64ToArrayBuffer(res.data)
                var a = window.document.createElement('a');
                a.href = window.URL.createObjectURL(new Blob([array], {
                        type: 'application/octet-stream'
                    })
                );
                a.download = 'FCOM ' + id + '.xlsx';
                document.body.appendChild(a)
                a.click();
                document.body.removeChild(a)
                this.$store.commit("setLoading", false);
            });
        },
    }
}
</script>